import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GameProvider } from "@/context/GameContext";
import Hub from "@/pages/Hub";
import Landing from "@/pages/Landing";
import Business from "@/pages/Business";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import EffectsLayer from "@/components/EffectsLayer";
import AvatarMakerDialog from "@/components/avatar/AvatarMakerDialog";
import PaywallModal from "@/components/PaywallModal";
import { Toaster } from "@/components/ui/sonner";
import { useGame } from "@/context/GameContext";

// Brand-new visitors see the landing page; anyone who has started playing goes straight to the game
const Home = () => {
  const { state } = useGame();
  return state.playerName || state.landingDone ? <Hub /> : <Landing />;
};

function App() {
  return (
    <div className="App">
      <GameProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/welcome" element={<Landing />} />
            <Route path="/business/:id" element={<Business />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          <EffectsLayer />
          <AvatarMakerDialog />
          <PaywallModal />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </GameProvider>
    </div>
  );
}

export default App;
